/** @jsxImportSource @emotion/react */

import { TVisit } from "apis/visitors/type";
import Header from "./header";
import Item from "./item";

export const VisitTable = ({ records, onClickItem }: { records: TVisit[]; onClickItem?: (record: TVisit) => void }) => {
    return (
        <div>
            <Header />
            {records.map((item, index) => {
                return (
                    <Item
                        record={item}
                        key={item.id}
                        onClick={(record) => {
                            onClickItem?.(record);
                        }}
                    />
                );
            })}
        </div>
    );
};

export default VisitTable;
